import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the view for managing product tables.
 * @extends JetView
 */

function getFilledValues(values) {
    var result = {};
    for (var key in values) {
        if (!values.hasOwnProperty(key)) continue;
        var v = values[key];
        var isEmpty = v === '' || v == null || (typeof v === 'string' && String(v).trim() === '');
        if (!isEmpty) result[key] = v;
    }
    return result;
}

export default class tableProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the data table
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('ProductsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'TypeDevice', // Column ID
                                    header: _('Dispositivo'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        {
                                            id: '1',
                                            value: "<span class='icon-phone'></span>",
                                        },
                                        {
                                            id: '2',
                                            value: "<span class='icon-display'></span>",
                                        },
                                        {
                                            id: '3',
                                            value: "<span class='icon-phone'></span><span class='icon-display'></span>",
                                        },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Image', // Column ID
                                    header: _('Imagen'), // Column header with localization
                                    width: 570, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Image2', // Column ID
                                    header: _('Imagen cuadrada'), // Column header with localization
                                    width: 570, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ProviderId', // Column ID
                                    header: _('Proveedor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CategoryName', // Column ID
                                    header: _('Categoría'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SubProviderId', // Column ID
                                    header: _('SubProveedor'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsVerified', // Column ID
                                    header: _('Verificado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId', // Column ID
                                    header: _('ID Externo'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ExternalId2', // Column ID
                                    header: _('ID Externo 2'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Visible', // Column ID
                                    header: _('Visible'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: _('Producto Id'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    var item = this.getItem(id); // Get the clicked item
                                    vthis.app.callEvent('editProduct:button', [
                                        item, // Pass the item to the event
                                    ]);
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable'); // Reference to the data table
        var url = devConfig.geturlApi() + 'Products/GetProducts'; // API URL for fetching products
        var filter = ''; // Filter string for data fetching
        let tagsList = []; // List to hold tags

        // Event listener for editing a product
        this.on(this.app, 'editProduct:button', (item) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories', // API URL for fetching categories
                    { global: true }, // Request payload
                    {
                        error: function () {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text) {
                            var resp = JSON.parse(text); // Parse the response
                            let tagsListExclude = []; // List for excluded tags
                            let tagsListInclude = ''; // List for included tags
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id; // Map ID
                                resp.data[i].value = resp.data[i].Description; // Map description
                            }
                            webix
                                .ui({
                                    view: 'window', // Create a window for editing
                                    id: 'editwinProducts', // Window ID
                                    width: Math.min(660, window.innerWidth - 40),
                                    height: Math.min(700, window.innerHeight - 40),
                                    maxHeight: '90vh',
                                    fullscreen: screen.width < 500 ? true : false,
                                    head: {
                                        view: 'toolbar', // Toolbar for window header
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Editar Producto'), // Label for editing product
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close the window
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the window
                                    modal: true, // Modal window
                                    body: {
                                        view: 'form', // Form for editing product details
                                        css: 'product-form',
                                        id: 'editform', // Form ID
                                        scroll: 'y', // Enable vertical scrolling
                                        elements: [
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Product ID
                                                        labelPosition: 'top',
                                                        label: _('Producto Id'), // Label for Product ID
                                                        name: 'Id', // Input name
                                                        readonly: true, // Read-only field
                                                    },
                                                    {
                                                        view: 'text', // Text input for Name
                                                        labelPosition: 'top',
                                                        label: _('Nombre'), // Label for Name
                                                        name: 'Name', // Input name
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Image URL
                                                        labelPosition: 'top',
                                                        label: _('Imagen URL'), // Label for Image URL
                                                        name: 'Image', // Input name
                                                    },
                                                    {
                                                        view: 'text', // Text input for Provider ID
                                                        labelPosition: 'top',
                                                        label: _('ID Provedor'), // Label for Provider ID
                                                        name: 'ProviderId', // Input name
                                                        readonly: true, // Read-only field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Status
                                                        labelPosition: 'top',
                                                        label: _('Estado'), // Label for Status
                                                        name: 'IsActivate', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Verificado'), // Label for Verified
                                                        name: 'IsVerified', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for External ID
                                                        labelPosition: 'top',
                                                        label: _('ID Externo'), // Label for External ID
                                                        name: 'ExternalId', // Input name
                                                        readonly: false, // Editable field
                                                    },
                                                    {
                                                        view: 'text', // Text input for External ID 2
                                                        labelPosition: 'top',
                                                        label: _(
                                                            'ID Externo 2', // Label for External ID 2
                                                        ),
                                                        name: 'ExternalId2', // Input name
                                                        required: false, // Not required
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Visibility
                                                        labelPosition: 'top',
                                                        label: _('Visible'), // Label for Visibility
                                                        name: 'Visible', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Mobile status
                                                        labelPosition: 'top',
                                                        label: _('Mobile'), // Label for Mobile
                                                        name: 'Mobile', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Desktop status
                                                        labelPosition: 'top',
                                                        label: _('Escritorio'), // Label for Desktop
                                                        name: 'Desktop', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'richselect', // Rich select for Category
                                                        name: 'Category', // Input name
                                                        localId: 'categorie:combo', // Local ID for the category combo
                                                        label: "<span class='icon-category'></span>" + _('Categorías'), // Label for Category
                                                        labelPosition: 'top',
                                                        placeholder: _(
                                                            'Click para seleccionar ', // Placeholder text
                                                        ),
                                                        options: resp.data, // Options for the category
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Theoretical RTP
                                                        labelPosition: 'top',
                                                        label:
                                                            "<span class='label-with-indicator'>" +
                                                            "<span class='label-text'>" +
                                                            _('RTP(Return to Player)') +
                                                            '</span>' +
                                                            "<div class='icon-exclamation-circle info-indicator'><span class='div-to-display'>" +
                                                            _('Valor entre 0 y 100.') +
                                                            '</span></div></span>',
                                                        name: 'TheoreticalRTP', // Input name
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                    {
                                                        view: 'text',
                                                        name: 'MinimumBet',
                                                        label:
                                                            "<span class='label-with-indicator'>" +
                                                            "<span class='label-text'>" +
                                                            _('Apuesta mínima') +
                                                            '</span>' +
                                                            "<span class='icon-exclamation-circle info-indicator'><span class='div-to-display'>" +
                                                            _('Debe ser menor a la apuesta máxima.') +
                                                            '</span></span></span>',
                                                        required: false, // Not required
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        type: 'number',
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        name: 'MaximumBet',
                                                        label:
                                                            "<span class='label-with-indicator'>" +
                                                            "<span class='label-text'>" +
                                                            _('Apuesta máxima') +
                                                            '</span>' +
                                                            "<span class='icon-exclamation-circle info-indicator'><span class='div-to-display'>" +
                                                            _('Debe ser mayor a la apuesta mínima.') +
                                                            '</span></span></span>',
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        required: false, // Not required
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                    {
                                                        view: 'text',
                                                        name: 'DefaultBet',
                                                        label: _('Apuesta por default'),
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        required: false, // Not required
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Dinámica de juego'), // Label for Verified
                                                        name: 'GameDynamics', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            {
                                                                id: 'INDIVIVDUAL',
                                                                value: _('Individual'),
                                                            },
                                                            {
                                                                id: 'MULTIJUGADOR',
                                                                value: _('Multijugador'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Volatilidad'), // Label for Verified
                                                        name: 'Volatility', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'MUY_ALTA',
                                                                value: _('Muy Alta'),
                                                            },
                                                            {
                                                                id: 'ALTA',
                                                                value: _('Alta'),
                                                            },
                                                            {
                                                                id: 'MEDIA',
                                                                value: _('Media'),
                                                            },
                                                            {
                                                                id: 'BAJA',
                                                                value: _('Baja'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        name: 'HitFrecuency',
                                                        label: _('Hit Frecuency'),
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        required: false, // Not required
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Jackpot disponible'), // Label for Verified
                                                        name: 'JackpotAvailable', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'S',
                                                                value: _('Si'),
                                                            },
                                                            {
                                                                id: 'N',
                                                                value: _('No'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        name: 'Paylines',
                                                        label: _('Líneas de pago'),
                                                        labelPosition: 'top',
                                                        placeholder: '0',
                                                        required: false,
                                                        attributes: {
                                                            oninput: "this.value = this.value.replace(/[^0-9]/g, '')",
                                                            onpaste:
                                                                "var e=this;setTimeout(function(){e.value=e.value.replace(/[^0-9]/g,'')},0)",
                                                        },
                                                        on: {
                                                            onKeyPress: function (code, e) {
                                                                if (!e || !e.key) {
                                                                    return (
                                                                        [8, 9, 37, 38, 39, 40, 46].indexOf(code) !==
                                                                            -1 ||
                                                                        (code >= 48 && code <= 57)
                                                                    );
                                                                }
                                                                // control keys
                                                                if (
                                                                    [
                                                                        'Backspace',
                                                                        'Tab',
                                                                        'Delete',
                                                                        'ArrowLeft',
                                                                        'ArrowRight',
                                                                        'ArrowUp',
                                                                        'ArrowDown',
                                                                    ].indexOf(e.key) !== -1
                                                                )
                                                                    return true;
                                                                return e.key.length === 1 && /^[0-9]$/.test(e.key);
                                                            },
                                                            onChange: function (newVal) {
                                                                if (newVal && !/^\d+$/.test(String(newVal))) {
                                                                    this.setValue(
                                                                        this.getValue().replace(/[^\d]/g, ''),
                                                                    );
                                                                }
                                                            }
                                                        },
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Multiplicadores disponibles'), // Label for Verified
                                                        name: 'AvailableMultipliers', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'S',
                                                                value: _('Si'),
                                                            },
                                                            {
                                                                id: 'N',
                                                                value: _('No'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Bonos especiales'), // Label for Verified
                                                        name: 'SpecialBonus', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false,
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'S',
                                                                value: _('Si'),
                                                            },
                                                            {
                                                                id: 'N',
                                                                value: _('No'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'datatable', // Data table for Tags
                                                id: 'TagsAdds', // Table ID
                                                name: 'TagsAdds', // Table name
                                                height: 300, // Table height
                                                columns: [
                                                    {
                                                        id: 'ch1', // Column ID for checkbox
                                                        header: [
                                                            {
                                                                content: 'masterCheckbox', // Master checkbox header
                                                            },
                                                        ],
                                                        checkValue: 'on', // Value when checked
                                                        uncheckValue: 'off', // Value when unchecked
                                                        template: '{common.checkbox()}', // Checkbox template
                                                        width: 40, // Column width
                                                    },
                                                    {
                                                        id: 'title', // Column ID for title
                                                        header: [
                                                            {
                                                                text: 'Etiqueta', // Header for Tags
                                                            },
                                                            {
                                                                content: 'textFilter', // Filter content
                                                            },
                                                        ],
                                                        fillspace: true, // Fill space
                                                        sort: 'string', // Sorting type
                                                        css: {
                                                            'text-align': 'left', // Text alignment
                                                        },
                                                    },
                                                ],
                                                scrollX: false, // Disable horizontal scrolling
                                                navigation: true, // Enable navigation
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'uploader', // Uploader for Image URL
                                                        upload: devConfig.geturlApi() + 'Product/UpdateProductDetails', // Upload URL
                                                        id: 'ImageURL', // Uploader ID
                                                        name: 'ImageURL', // Uploader name
                                                        value: _(
                                                            'Agregar imagen', // Button text
                                                        ),
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            userid: 123, // User ID for form data
                                                            document: 'attachment', // Document type
                                                        },
                                                    },
                                                    {
                                                        view: 'uploader', // Uploader for Image2 URL
                                                        upload: devConfig.geturlApi() + 'Product/UpdateProductDetails2', // Upload URL
                                                        id: 'ImageURL2', // Uploader ID
                                                        name: 'ImageURL2', // Uploader name
                                                        value: _(
                                                            'Agregar imagen cuadrada', // Button text
                                                        ),
                                                        autosend: false, // Disable auto send
                                                        formData: {
                                                            userid: 123, // User ID for form data
                                                            document: 'attachment', // Document type
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Note
                                                        labelPosition: 'top',
                                                        label: _('Explicación'), // Label for Note
                                                        name: 'Note', // Input name
                                                        labelWidth: 160, // Label width
                                                        attributes: {
                                                            type: 'text', // Input type
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: _('Cancelar'), // Button text
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Close the window
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form', // Button type
                                                        value: _('Guardar'), // Button text
                                                        click: function ($e) {
                                                            // Click event for save button
                                                            if (
                                                                Object.keys($$('ImageURL').files.data.pull).length > 0
                                                            ) {
                                                                var values = $$('editform').getValues(); // Get form values
                                                                // Validate: maximum bet > minimum bet
                                                                $$('ImageURL').config.formData.Id = values.Id; // Set ID in form data
                                                                $$('ImageURL').config.formData.IsActivate =
                                                                    values.IsActivate; // Set activation status
                                                                $$('ImageURL').config.formData.IsVerified =
                                                                    values.IsVerified; // Set verification status
                                                                $$('ImageURL').config.formData.Visible = values.Visible; // Set visibility
                                                                $$('ImageURL').config.formData.Mobile = values.Mobile; // Set mobile status
                                                                $$('ImageURL').config.formData.Desktop = values.Desktop; // Set desktop status
                                                                $$('ImageURL').send(function (response) {
                                                                    webix.message(
                                                                        'Producto Editado', // Success message
                                                                    );
                                                                });
                                                                grid.clearAll(); // Clear the grid
                                                                grid.load(
                                                                    url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter, // Reload grid data
                                                                );
                                                                this.getTopParentView().hide(); // Close the window
                                                            } else {
                                                                if (
                                                                    Object.keys($$('ImageURL2').files.data.pull)
                                                                        .length > 0
                                                                ) {
                                                                    var values = $$('editform').getValues(); // Get form values
                                                                    $$('ImageURL2').config.formData.Id = values.Id; // Set ID in form data
                                                                    $$('ImageURL2').config.formData.IsActivate =
                                                                        values.IsActivate; // Set activation status
                                                                    $$('ImageURL2').config.formData.IsVerified =
                                                                        values.IsVerified; // Set verification status
                                                                    $$('ImageURL2').config.formData.Visible =
                                                                        values.Visible; // Set visibility
                                                                    $$('ImageURL2').config.formData.Mobile =
                                                                        values.Mobile; // Set mobile status
                                                                    $$('ImageURL2').config.formData.Desktop =
                                                                        values.Desktop; // Set desktop status
                                                                    $$('ImageURL2').send(function (response) {
                                                                        webix.message(
                                                                            'Producto Editado', // Success message
                                                                        );
                                                                    });
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter, // Reload grid data
                                                                    );
                                                                    this.getTopParentView().hide(); // Close the window
                                                                } else {
                                                                    let values = $$('editform').getValues(); // Get form values
                                                                    var minBet = values.MinimumBet
                                                                        ? parseFloat(String(values.MinimumBet).trim())
                                                                        : null;
                                                                    var maxBet = values.MaximumBet
                                                                        ? parseFloat(String(values.MaximumBet).trim())
                                                                        : null;
                                                                    if (
                                                                        minBet != null &&
                                                                        maxBet != null &&
                                                                        minBet >= maxBet
                                                                    ) {
                                                                        webix.message({
                                                                            type: 'error',
                                                                            text: _(
                                                                                'La apuesta máxima debe ser mayor que la apuesta mínima',
                                                                            ),
                                                                        });
                                                                        return;
                                                                    }

                                                                    // Validate: RTP between 0 and 100, or null/empty
                                                                    var TheoreticalRTPVal = values.TheoreticalRTP;
                                                                    if (
                                                                        TheoreticalRTPVal !== '' &&
                                                                        TheoreticalRTPVal != null &&
                                                                        String(TheoreticalRTPVal).trim() !== ''
                                                                    ) {
                                                                        var n = parseFloat(TheoreticalRTPVal);
                                                                        if (isNaN(n) || n < 0 || n > 100) {
                                                                            webix.message({
                                                                                type: 'error',
                                                                                text: _(
                                                                                    'RTP debe ser un valor entre 0 y 100.',
                                                                                ),
                                                                            });
                                                                            return;
                                                                        }
                                                                    }
                                                                    var numericFields = [
                                                                        'Paylines',
                                                                        'MinimumBet',
                                                                        'MaximumBet',
                                                                        'DefaultBet',
                                                                        'HitFrecuency',
                                                                        'TheoreticalRTP',
                                                                    ];
                                                                    numericFields.forEach(function (fieldName) {
                                                                        var v = values[fieldName];
                                                                        var isEmpty =
                                                                            v === '' ||
                                                                            v == null ||
                                                                            (typeof v === 'string' &&
                                                                                String(v).trim() === '');
                                                                        if (isEmpty) {
                                                                            values[fieldName] = '';
                                                                        } else {
                                                                            var num =
                                                                                fieldName === 'Paylines'
                                                                                    ? parseInt(v, 10)
                                                                                    : parseFloat(v);
                                                                            values[fieldName] = isNaN(num) ? null : num;
                                                                        }
                                                                    });

                                                                    let tagsValue = $$('TagsAdds').serialize(); // Serialize tags
                                                                    let newTagsListExclude = tagsValue.filter(
                                                                        (item) => item.ch1 === 'off', // Filter excluded tags
                                                                    );
                                                                    newTagsListExclude = newTagsListExclude.map(
                                                                        (item) => item.id, // Map excluded tag IDs
                                                                    );
                                                                    let newTagsListInclude = tagsValue.filter(
                                                                        (item) => item.ch1 === 'on', // Filter included tags
                                                                    );
                                                                    newTagsListInclude = newTagsListInclude.map(
                                                                        (item) => item.id, // Map included tag IDs
                                                                    );
                                                                    newTagsListInclude = newTagsListInclude.filter(
                                                                        (item) =>
                                                                            !tagsListInclude.includes(
                                                                                item, // Exclude already included tags
                                                                            ),
                                                                    );
                                                                    let valueTags = {
                                                                        ProductId: item.Id, // Product ID
                                                                        ExcludedTagList: newTagsListExclude.toString(), // Excluded tags
                                                                        IncludedTagList: newTagsListInclude.toString(), // Included tags
                                                                    };
                                                                    var win = this.getTopParentView();
                                                                    webix
                                                                        .ajax()
                                                                        .headers({
                                                                            'Content-type': 'application/json', // Set content type for AJAX request
                                                                        })
                                                                        .post(
                                                                            devConfig.geturlApi() +
                                                                                'Product/UpdateProductDetails', // API URL for updating product details
                                                                            values, // Request payload
                                                                            {
                                                                                error: function (
                                                                                    text,
                                                                                    data,
                                                                                    XmlHttpRequest,
                                                                                ) {
                                                                                    webix.message(
                                                                                        'Error! ', // Error message on failure
                                                                                    );
                                                                                },
                                                                                success: function (text, data, XmlHttpRequest) {
                                                                                var resp = JSON.parse(text);
                                                                                if (resp.HasError) {
                                                                                    webix.message({ type: 'error', text: 'Error: ' + (resp.AlertMessage || 'No se pudo editar el producto') });
                                                                                    return;
                                                                                }
                                                                                webix.message('Producto Editado');
                                                                                grid.clearAll();
                                                                                grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
                                                                                win.hide();
                                                                            },
                                                                            },
                                                                        );
                                                                    if (
                                                                        newTagsListExclude.length > 0 ||
                                                                        newTagsListInclude.length > 0
                                                                    ) {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type for AJAX request
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'Tag/saveGroupTags2', // API URL for saving tags
                                                                                valueTags, // Request payload
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message on failure
                                                                                        );
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Etiquetas Guardadas', // Success message
                                                                                        );
                                                                                    },
                                                                                },
                                                                            );
                                                                    }

                                                                    if (grid.showProgress) {
                                                                        webix.extend(grid, webix.ProgressBar);
                                                                        grid.showProgress({ type: 'icon', delay: 0 });
                                                                    }
                                                                    setTimeout(function () {
                                                                        grid.clearAll();
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter,
                                                                        );
                                                                        if (grid.hideProgress) grid.hideProgress();
                                                                    }, 800);
                                                                    this.getTopParentView().hide();
                                                                }
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                })
                                .show(); // Show the edit window
                            webix.ajax().get(
                                devConfig.geturlApi() + 'Tag/GetGroupTagsProducts', // API URL for fetching product tags
                                { Id: item.Id }, // Request payload
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var data2 = JSON.parse(text); // Parse the response
                                        if (!data2.HasError) {
                                            tagsListExclude = data2.Data.ExcludedTagList.map((item) => {
                                                return {
                                                    id: item.id, // Map excluded tag ID
                                                    title: item.value, // Map excluded tag title
                                                };
                                            });
                                            tagsListInclude = data2.Data.IncludedTagList; // Get included tags
                                            tagsListExclude = tagsListExclude.map((item) => {
                                                if (
                                                    tagsListInclude.includes(
                                                        item.id, // Check if included
                                                    )
                                                ) {
                                                    item.ch1 = 'on'; // Mark as included
                                                }
                                                return item; // Return modified item
                                            });
                                            $$('TagsAdds').parse(
                                                tagsListExclude, // Parse excluded tags into the table
                                            );
                                        } else {
                                            webix.message('Error! '); // Error message on failure
                                        }
                                    },
                                },
                            );
                            $$('editform').setValues(item); // Set form values to the selected item
                        },
                    },
                );
        });

        // Event listener for adding a product
        this.on(this.app, 'addProduct:button', (filter) => {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(
                    devConfig.geturlApi() + 'Categories/GetCategories', // API URL for fetching categories
                    { global: true }, // Request payload
                    {
                        error: function () {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text) {
                            var resp = JSON.parse(text); // Parse the response
                            for (var i = 0; i < resp.data.length; i++) {
                                resp.data[i].id = resp.data[i].Id; // Map ID
                                resp.data[i].value = resp.data[i].Description; // Map description
                            }
                            webix
                                .ui({
                                    view: 'window', // Create a window for adding a product
                                    id: 'AddProducts', // Window ID
                                    width: Math.min(660, window.innerWidth - 40),
                                    height: Math.min(700, window.innerHeight - 40),
                                    maxHeight: '90vh',
                                    fullscreen: screen.width < 500 ? true : false,
                                    head: {
                                        view: 'toolbar', // Toolbar for window header
                                        cols: [
                                            {
                                                view: 'label',
                                                label: _('Añadir Producto'), // Label for adding product
                                            },
                                            {
                                                view: 'icon',
                                                icon: 'wxi-close', // Close icon
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close the window
                                                },
                                            },
                                        ],
                                    },
                                    position: 'center', // Center the window
                                    modal: true, // Modal window
                                    body: {
                                        view: 'form', // Form for adding product details
                                        css: 'product-form',
                                        id: 'addform', // Form ID
                                        scroll: 'y', // Enable vertical scrolling,
                                        elements: [
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Name
                                                        labelPosition: 'top',
                                                        label: _('Nombre'), // Label for Name
                                                        name: 'Name', // Input name
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Provider
                                                        labelPosition: 'top',
                                                        label: _('Proveedor'), // Label for Provider
                                                        name: 'ProviderId', // Input name
                                                        options: {
                                                            body: {
                                                                dataFeed: function (text) {
                                                                    var vthis = this; // Reference to the current context
                                                                    if (text.length > 2) {
                                                                        webix
                                                                            .ajax()
                                                                            .headers({
                                                                                'Content-type': 'application/json', // Set content type for AJAX request
                                                                            })
                                                                            .post(
                                                                                devConfig.geturlApi() +
                                                                                    'es/Select/SubProvidersCasinoSelect', // API URL for fetching subproviders
                                                                                '{"Filter":"' + text + '"}', // Request payload
                                                                                {
                                                                                    error: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        webix.message(
                                                                                            'Error! ', // Error message on failure
                                                                                        );
                                                                                    },
                                                                                    success: function (
                                                                                        text,
                                                                                        data,
                                                                                        XmlHttpRequest,
                                                                                    ) {
                                                                                        var resp = JSON.parse(
                                                                                            text, // Parse the response
                                                                                        );
                                                                                        if (!resp.HasError) {
                                                                                            vthis.parse(
                                                                                                resp.Data, // Parse the data into the combo
                                                                                            );
                                                                                        }
                                                                                    },
                                                                                },
                                                                            );
                                                                    }
                                                                },
                                                            },
                                                        },
                                                        required: true, // Required field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Status
                                                        labelPosition: 'top',
                                                        label: _('Estado'), // Label for Status
                                                        name: 'IsActivate', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Visibility
                                                        labelPosition: 'top',
                                                        label: _('Visible'), // Label for Visibility
                                                        name: 'Visible', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for External ID
                                                        labelPosition: 'top',
                                                        label: _('ID Externo'), // Label for External ID
                                                        name: 'ExternalId', // Input name
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'text', // Text input for External ID 2
                                                        labelPosition: 'top',
                                                        label: _(
                                                            'ID Externo 2', // Label for External ID 2
                                                        ),
                                                        name: 'ExternalId2', // Input name
                                                        required: false, // Not required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Mobile status
                                                        labelPosition: 'top',
                                                        label: _('Movíl'), // Label for Mobile
                                                        name: 'Mobile', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Desktop status
                                                        labelPosition: 'top',
                                                        label: _('Escritorio'), // Label for Desktop
                                                        name: 'Desktop', // Input name
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                        required: true, // Required field
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text', // Text input for Theoretical RTP
                                                        labelPosition: 'top',
                                                        name: 'TheoreticalRTP', // Input name
                                                        label:
                                                            "<span class='label-with-indicator'>" +
                                                            "<span class='label-text'>" +
                                                            _('RTP(Return to Player)') +
                                                            '</span>' +
                                                            "<span class='icon-exclamation-circle info-indicator'><span class='div-to-display'>" +
                                                            _('Valor entre 0 y 100.') +
                                                            '</span></span></span>',
                                                        placeholder: '0.00',
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                    {
                                                        view: 'richselect', // Rich select for Category
                                                        name: 'Category', // Input name
                                                        localId: 'categorie:combo', // Local ID for the category combo
                                                        label: "<span class='icon-category'></span>" + _('Categorías'), // Label for Category
                                                        labelPosition: 'top',
                                                        placeholder: _(
                                                            'Click para seleccionar ', // Placeholder text
                                                        ),
                                                        options: resp.data, // Options for the category
                                                        required: false, // Not required
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Verificado'), // Label for Verified
                                                        name: 'IsVerified', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'A',
                                                                value: _('Activado'),
                                                            },
                                                            {
                                                                id: 'I',
                                                                value: _('Inactivado'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'text',
                                                        name: 'MinimumBet',
                                                        label:
                                                            "<span class='label-with-indicator'>" +
                                                            "<span class='label-text'>" +
                                                            _('Apuesta mínima') +
                                                            '</span>' +
                                                            "<span class='icon-exclamation-circle info-indicator'><span class='div-to-display'>" +
                                                            _('Debe ser menor a la apuesta máxima.') +
                                                            '</span></span></span>',
                                                        required: false, // Not required
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        type: 'number',
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        name: 'MaximumBet',
                                                        label:
                                                            "<span class='label-with-indicator'>" +
                                                            "<span class='label-text'>" +
                                                            _('Apuesta máxima') +
                                                            '</span>' +
                                                            "<span class='icon-exclamation-circle info-indicator'><span class='div-to-display'>" +
                                                            _('Debe ser mayor a la apuesta mínima.') +
                                                            '</span></span></span>',
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        required: false, // Not required
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                    {
                                                        view: 'text',
                                                        name: 'DefaultBet',
                                                        label: _('Apuesta por default'),
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        required: false, // Not required
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Dinámica de juego'),
                                                        name: 'GameDynamics', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            {
                                                                id: 'INDIVIVDUAL',
                                                                value: _('Individual'),
                                                            },
                                                            {
                                                                id: 'MULTIJUGADOR',
                                                                value: _('Multijugador'),
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Volatilidad'),
                                                        name: 'Volatility', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'MUY_ALTA',
                                                                value: _('Muy Alta'),
                                                            },
                                                            {
                                                                id: 'ALTA',
                                                                value: _('Alta'),
                                                            },
                                                            {
                                                                id: 'MEDIA',
                                                                value: _('Media'),
                                                            },
                                                            {
                                                                id: 'BAJA',
                                                                value: _('Baja'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        name: 'HitFrecuency',
                                                        label: _('Hit Frecuency'),
                                                        labelPosition: 'top',
                                                        placeholder: '0.00',
                                                        required: false, // Not required
                                                        type: 'number',
                                                        required: false, // Not required
                                                        onChange: function (newVal) {
                                                            if (!newVal) return;
                                                            var v = String(newVal);
                                                            var cleaned = v.replace(/[^0-9.]/g, '');
                                                            var parts = cleaned.split('.');
                                                            if (parts.length > 2)
                                                                cleaned = parts[0] + '.' + parts.slice(1).join('');
                                                            if (cleaned !== v) this.setValue(cleaned);
                                                        },
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Jackpot disponible'), // Label for Verified
                                                        name: 'JackpotAvailable', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'S',
                                                                value: _('Si'),
                                                            },
                                                            {
                                                                id: 'N',
                                                                value: _('No'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'text',
                                                        name: 'Paylines',
                                                        label: _('Líneas de pago'),
                                                        labelPosition: 'top',
                                                        placeholder: '0',
                                                        required: false,
                                                        attributes: {
                                                            oninput: "this.value = this.value.replace(/[^0-9]/g, '')",
                                                            onpaste:
                                                                "var e=this;setTimeout(function(){e.value=e.value.replace(/[^0-9]/g,'')},0)",
                                                        },
                                                        on: {
                                                            onKeyPress: function (code, e) {
                                                                if (!e || !e.key) {
                                                                    return (
                                                                        [8, 9, 37, 38, 39, 40, 46].indexOf(code) !==
                                                                            -1 ||
                                                                        (code >= 48 && code <= 57)
                                                                    );
                                                                }
                                                                // control keys
                                                                if (
                                                                    [
                                                                        'Backspace',
                                                                        'Tab',
                                                                        'Delete',
                                                                        'ArrowLeft',
                                                                        'ArrowRight',
                                                                        'ArrowUp',
                                                                        'ArrowDown',
                                                                    ].indexOf(e.key) !== -1
                                                                )
                                                                    return true;
                                                                return e.key.length === 1 && /^[0-9]$/.test(e.key);
                                                            },
                                                            onChange: function (newVal) {
                                                                if (newVal && !/^\d+$/.test(String(newVal))) {
                                                                    this.setValue(
                                                                        this.getValue().replace(/[^\d]/g, ''),
                                                                    );
                                                                }
                                                            }
                                                        },
                                                    },
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Multiplicadores disponibles'), // Label for Verified
                                                        name: 'AvailableMultipliers', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false, // Not required
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'S',
                                                                value: _('Si'),
                                                            },
                                                            {
                                                                id: 'N',
                                                                value: _('No'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                margin: 10,
                                                cols: [
                                                    {
                                                        view: 'combo', // Combo box for Verified status
                                                        labelPosition: 'top',
                                                        label: _('Bonos especiales'), // Label for Verified
                                                        name: 'SpecialBonus', // Input name
                                                        placeholder: 'Click para seleccionar',
                                                        required: false,
                                                        options: [
                                                            // Options for the combo box
                                                            {
                                                                id: 'S',
                                                                value: _('Si'),
                                                            },
                                                            {
                                                                id: 'N',
                                                                value: _('No'),
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'datatable', // Data table for Tags
                                                id: 'TagsAdds', // Table ID
                                                name: 'TagsAdds', // Table name
                                                height: 200, // Table height
                                                columns: [
                                                    {
                                                        id: 'ch1', // Column ID for checkbox
                                                        header: '', // Header for checkbox column
                                                        checkValue: 'on', // Value when checked
                                                        uncheckValue: 'off', // Value when unchecked
                                                        template: '{common.checkbox()}', // Checkbox template
                                                        width: 40, // Column width
                                                    },
                                                    {
                                                        id: 'title', // Column ID for title
                                                        header: [
                                                            {
                                                                text: 'Etiqueta', // Header for Tags
                                                            },
                                                            {
                                                                content: 'textFilter', // Filter content
                                                            },
                                                        ],
                                                        fillspace: true, // Fill space
                                                        sort: 'string', // Sorting type
                                                    },
                                                ],
                                                scrollX: false, // Disable horizontal scrolling
                                                navigation: true, // Enable navigation
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button', // Cancel button
                                                        value: _('Cancelar'), // Button text
                                                        click: function () {
                                                            this.getTopParentView().hide(); // Close the window
                                                            $$('addform').setValues(
                                                                $$('addform').getCleanValues(), // Reset form values
                                                            );
                                                        },
                                                    },
                                                    {
                                                        view: 'button', // Save button
                                                        type: 'form', // Button type
                                                        value: _('Guardar'), // Button text
                                                        click: function ($e) {
                                                            // Click event for save button
                                                            if (
                                                                $$('addform').validate() // Validate form
                                                            ) {
                                                                var values = $$('addform').getValues(); // Get form values
                                                                // Validate: maximum bet > minimum bet
                                                                var minBet = values.MinimumBet
                                                                    ? parseFloat(String(values.MinimumBet).trim())
                                                                    : null;
                                                                var maxBet = values.MaximumBet
                                                                    ? parseFloat(String(values.MaximumBet).trim())
                                                                    : null;
                                                                if (
                                                                    minBet != null &&
                                                                    maxBet != null &&
                                                                    minBet >= maxBet
                                                                ) {
                                                                    webix.message({
                                                                        type: 'error',
                                                                        text: _(
                                                                            'La apuesta máxima debe ser mayor que la apuesta mínima',
                                                                        ),
                                                                    });
                                                                    return;
                                                                }

                                                                // Validate: RTP  between 0 and 100, or null/empty
                                                                var TheoreticalRTPVal = values.TheoreticalRTP;
                                                                if (
                                                                    TheoreticalRTPVal !== '' &&
                                                                    TheoreticalRTPVal != null &&
                                                                    String(TheoreticalRTPVal).trim() !== ''
                                                                ) {
                                                                    var n = parseFloat(TheoreticalRTPVal);
                                                                    if (isNaN(n) || n < 0 || n > 100) {
                                                                        webix.message({
                                                                            type: 'error',
                                                                            text: _(
                                                                                'RTP debe ser un valor entre 0 y 100.',
                                                                            ),
                                                                        });
                                                                        return;
                                                                    }
                                                                }
                                                                var numericFields = [
                                                                    'Paylines',
                                                                    'MinimumBet',
                                                                    'MaximumBet',
                                                                    'DefaultBet',
                                                                    'HitFrecuency',
                                                                    'TheoreticalRTP',
                                                                ];
                                                                numericFields.forEach(function (fieldName) {
                                                                    var v = values[fieldName];
                                                                    var isEmpty =
                                                                        v === '' ||
                                                                        v == null ||
                                                                        (typeof v === 'string' &&
                                                                            String(v).trim() === '');
                                                                    if (isEmpty) {
                                                                        values[fieldName] = null;
                                                                    } else {
                                                                        var num =
                                                                            fieldName === 'Paylines'
                                                                                ? parseInt(v, 10)
                                                                                : parseFloat(v);
                                                                        values[fieldName] = isNaN(num) ? null : num;
                                                                    }
                                                                });

                                                                let tagsSelected = $$('TagsAdds').serialize(); // Serialize tags
                                                                tagsSelected = tagsSelected.filter(
                                                                    (item) => item.ch1 === 'on', // Filter selected tags
                                                                );
                                                                tagsSelected = tagsSelected.map(
                                                                    (item) => item.id, // Map selected tag IDs
                                                                );
                                                                var win = this.getTopParentView();
                                                                values.TagsAdd = tagsSelected.toString(); // Add selected tags to values
                                                                values = getFilledValues(values);
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Product/UpdateProductDetails', // API URL for updating product details
                                                                        values, // Request payload
                                                                        {
                                                                            error: function () {
                                                                                webix.message(
                                                                                    'Error! ', // Error message on failure
                                                                                );
                                                                            },
                                                                            success: function (text) {
                                                                                text = JSON.parse(
                                                                                    text, // Parse the response
                                                                                );
                                                                                if (text.HasError) {
                                                                                    webix.message(
                                                                                        'Error: ' + text.AlertMessage, // Error message on failure
                                                                                    );
                                                                                } else {
                                                                                    webix.message(
                                                                                        'Producto Agregado', // Success message
                                                                                    );
                                                                                    win.hide();
                                                                                    grid.clearAll(); // Clear the grid
                                                                                    grid.load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            grid.data.$pagesize +
                                                                                            filter, // Reload grid data
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                            } else {
                                                                webix.message({
                                                                    title: _(
                                                                        '¡Error!', // Error title
                                                                    ),
                                                                    type: 'alert-error', // Error type
                                                                    text: _(
                                                                        'Completa los campos...', // Error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {},
                                            },
                                        },
                                    },
                                })
                                .show(); // Show the add window
                            webix.ajax().get(
                                devConfig.geturlApi() + 'Tag/GetTags', // API URL for fetching tags
                                '',
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        text = JSON.parse(text); // Parse the response
                                        let tagsDblList = $$('TagsAdds'); // Reference to the tags data table
                                        tagsDblList.parse(
                                            text.data.map((item) => {
                                                return {
                                                    id: item.Id, // Map tag ID
                                                    title: item.Name, // Map tag title
                                                };
                                            }),
                                        ); // Parse tags into the table
                                    },
                                },
                            );
                        },
                    },
                );
        });

        // Event listener for filtering products
        this.on(this.app, 'products:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&Column=' + by + '&Sort=' + dir, // Load sorted data
            );
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Call event with item ID
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by player ID
            );
        });
    }
}

// FILE DOCUMENTED
